import { render, staticRenderFns } from "./ekk_menu.vue?vue&type=template&id=10f55e10&scoped=true"
import script from "./ekk_menu.vue?vue&type=script&lang=js"
export * from "./ekk_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f55e10",
  null
  
)

export default component.exports